<mat-form-field appearance="fill">
    <mat-label>Has Tags</mat-label>
    <mat-chip-grid #chipList aria-label="Created By">
        @for (tag of tags; track tag) {
            <mat-chip-row (removed)="remove(tag)">
                {{ tag.name }}
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
        }
        <input
            #tagInput
            [formControl]="tagControl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        @for (tag of filteredTags$ | async; track tag) {
            <mat-option [value]="tag">
                {{ tag.name }}
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
